import { OrderManagementSection } from '@modules/common/models'
import { stores } from '@stores'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import useStyles from './OrderDetailsStyle'
import Typography from '@components/std-components/Typography'
import MdcKeyboardBackspace from '@meronex/icons/mdc/MdcKeyboardBackspace'
import { Link } from 'react-router-dom'
import { View } from '@modules/order/constants/views'
import { useTranslation } from 'react-i18next'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { lightTheme } from '@core/system/theme'
import EnhancedOrderContainer from '@modules/showroom/EnhancedOrder/containers/EnhancedOrderContainer'
import { ENHANCED_VIEW_ROUTES } from '@modules/showroom/productCollection/enhancedView/constants/cnf-product-constants'

export const EnhancedOrderDetails = () => {
  return useObserver(function useHook() {
    let {
      nav: {
        queryParams: { zone, section, buyingSessionGroupId, view, tab }
      }
    } = stores
    const classes = useStyles()
    const basePath = '/wholesale/buyingSessionGroup'
    const pathname = `${basePath}/${ENHANCED_VIEW_ROUTES.orderCollection}`
    const { t } = useTranslation()
    return (
      <div className={classes.orderDetailsWrapper}>
        {/* Applying new theme to match it with showroom orders UI */}
        <MuiThemeProvider theme={lightTheme}>
          <EnhancedOrderContainer
            baseUrlNavIconConfig={{
              name: 'navBack',
              isCustomElement: true,
              customElement: () => (
                <Link
                  className={classes.backToOrdersContainer}
                  to={`${pathname}?buyingSessionGroupId=${buyingSessionGroupId}&section=${
                    section ?? OrderManagementSection.clientOrder
                  }&view=${zone ?? undefined}&tab=${tab}`}
                >
                  <MdcKeyboardBackspace size={18} className={classes.arrowBack} />
                  <Typography variant={'lookTitle'} color={'primary'}>
                    {t('common.label.back', 'Back')}
                  </Typography>
                </Link>
              ),
              showIcon: view !== View.AddProduct,
              basePath
            }}
          />
        </MuiThemeProvider>
      </div>
    )
  })
}
